import { render, staticRenderFns } from "./FormInfo.vue?vue&type=template&id=665bf3e6&scoped=true&"
import script from "./FormInfo.vue?vue&type=script&lang=js&"
export * from "./FormInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormInfo.vue?vue&type=style&index=0&id=665bf3e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bf3e6",
  null
  
)

export default component.exports